import { ProductCode } from '@insurance/types'
import { Col } from 'antd'

import { FinancialProductConfig } from './FinancialProductConfig'
import { ComponentProps } from './types'

type Props = {
  code?: ProductCode
  componentProps: ComponentProps
}

const productsMap: Partial<
  Record<ProductCode, React.ComponentType<ComponentProps>>
> = {
  [ProductCode.FINANCIAL]: FinancialProductConfig
}

export const ProductsConfigParams = ({ code, componentProps }: Props) => {
  if (!code) return null

  const Component = productsMap[code]

  if (!Component) return null

  return (
    <Col span={22}>
      <Component {...componentProps} />
    </Col>
  )
}
